export default __webpack_public_path__ + "img/accha/accha4_700.webp";